import { serviceColumns } from '@Constants/TableColumns';
import { EnumFrontendLayoutSetting, type ApiService, ApiImportExternalErpItemsRequest } from '@Model';
import { useStammdatenRepository } from '@Hooks/useRepository';
import { ExternalErpServicesRepository } from '@Repositories/Stammdaten';
import { useCallback } from 'react';
import type { ListRequest } from '@synqo/frontend-component-library';
import { type ImportFlowControlProps, ImportExternalErpItemsFlow } from './ImportExternalErpItemsFlow';

// @ai-generated 2026-10-22T13:20:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function ImportExternalErpServicesFlow({ isOpen, onClose, onImported }: ImportFlowControlProps) {
    const repository = useStammdatenRepository(ExternalErpServicesRepository);

    const loadImportable = useCallback(
        (listRequest: ListRequest) => repository.getImportableServices(listRequest),
        [repository],
    );
    const importSelected = useCallback(
        (request: ApiImportExternalErpItemsRequest) => repository.importServices(request),
        [repository],
    );

    return (
        <ImportExternalErpItemsFlow<ApiService>
            isOpen={isOpen}
            onClose={onClose}
            onImported={onImported}
            title="Leistungen aus ERP importieren"
            name="ErpServiceList"
            itemsLabel="Leistungen"
            columns={serviceColumns}
            layoutSettingsContext={EnumFrontendLayoutSetting.ServicesTableLayout}
            loadImportable={loadImportable}
            importSelected={importSelected}
        />
    );
}
